import styled from "styled-components";

export const StyledHowToSayItWrapper = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.sm};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-bottom: ${({ theme }) => theme.space.sm};
    margin-bottom: 0;
    &:last-child {
      padding-bottom: 0;
    }
  }

  @media print {
    padding-bottom: 0;
  }
`;

export const StyledHowToSayItLabel = styled.div`
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  hyphens: auto;
  word-break: break-word;

  margin-right: ${({ theme }) => theme.space.xs};
`;

export const StyledAdditionalDataParentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledAdditionalDataWrapper = styled.div`
  max-width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: calc(100% - 180px);
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: calc(100% - 240px);
  }
`;
